/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AccountName from "../../../../../components/_utils/AccountCreationComponents/AccountName";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import {
  internalAccountDetailsById,
  resetEditInternalAccount,
  updateInternalAccount,
} from "../../../../../redux/features/accounts/internalAccount";
import globalText from "../../../../../utils/globalText";
import Validation from "../../../../../utils/validation";

const InternalAccountEditContact = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});

  //useSelector
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const { internalAccountDetailsData, internalAccountDetailsLoading } =
    useSelector((state) => state.internalAccount);

  const [selectedValue, setSelectedValue] = useState("");
  const [isLeavePopupOpen, setIsLeavePopupOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isUpdatingAccount, setIsUpdatingAccount] = useState(false);
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(false);
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
  });

  const internalAccountData = internalAccountDetailsData?.internal_accounts[0];

  const contactNumberValidation =
    Validation.allowedContactNum(payload.contact_no) &&
    !customErrors.contact_no;

  const emailValidation =
    Validation.allowedEmail(payload.email_id) && !customErrors.email_id;

  const accountNameValidation =
    payload.account_name.trim().length >= 3 && !customErrors.account_name;

  const handleBack = () => {
    if (hasUnsavedChanges) {
      setIsLeavePopupOpen(true);
      return;
    }
    navigate(-1);
  };

  const handleLeavePage = () => {
    navigate(-1);
  };

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "Contact details",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: isUpdateButtonEnabled
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextIsEnabled: isUpdateButtonEnabled,
      nextIsLoading: isUpdatingAccount,
      nextLoaderNeeded: true,
      nextHoverOption: "black",
    },
  ];

  const handleRadioBtn = (event) => {
    setSelectedValue(event.target.value);
    handleUpdateLegalName(event.target.value);
  };
  const handleDivBtn = (value) => {
    setSelectedValue(value);
    handleUpdateLegalName(value);
  };

  const sanitizeValue = (name, value) => {
    const sanitized =
      name === "account_name" ? value : value.replace(/[^a-zA-Z0-9@.]/g, "");

    return ["account_name", "name"].includes(name)
      ? sanitized
      : sanitized.trim();
  };

  const validationMap = {
    contact_no: Validation.allowedContactNum,
    email_id: Validation.allowedEmail,
  };

  const allowedValue = (name, value) => validationMap[name]?.(value) ?? true;

  const errorValidationMap = {
    contact_no: Validation.validateContactNum,
    email_id: Validation.validateEmail,
    account_name: Validation.validateAccountName,
  };

  const validateAndRecordError = (name, value) => {
    const validator = errorValidationMap[name];

    if (!validator) return;

    setCustomErrors((prev) => validator(name, value, { ...prev }));
  };

  const checkAllValidations = () => contactNumberValidation && emailValidation;

  const getUpdatedFields = () => {
    const updatedFields = [];

    if (internalAccountData?.contact_no !== payload.contact_no) {
      updatedFields.push("contact_no");
    }

    if ((internalAccountData?.email_id).trim() !== payload.email_id.trim()) {
      updatedFields.push("email_id");
    }

    if ((internalAccountData?.name).trim() !== payload.account_name.trim()) {
      updatedFields.push("account_name");
    }

    return updatedFields.length
      ? updatedFields
      : ["contact_no", "email_id", "account_name"];
  };

  const handleUpdateLegalName = (value) => {
    if (!internalAccountData) return;

    setPayload((prev) => {
      const isLegalName = value === "legalname";

      const keepCurrent =
        prev.account_name.trim() &&
        prev.account_name.trim() !== internalAccountData.pan_legal_name.trim();

      return {
        ...prev,
        account_name: isLegalName
          ? internalAccountData.pan_legal_name
          : keepCurrent
            ? prev.account_name
            : internalAccountData.name,
      };
    });
  };

  const handleChange = ({ target }) => {
  const { name, value } = target;

  if (value.includes("  ")) return;

  const newValue = sanitizeValue(name, value);

  if (!allowedValue(name, value)) return;

  validateAndRecordError(name, newValue);

  setPayload((prev) => {
    const updatedPayload = {
      ...prev,
      [name]: newValue,
    };

    setHasUnsavedChanges(
      internalAccountData?.contact_no !== updatedPayload.contact_no ||
        internalAccountData?.email_id.trim() !==
          updatedPayload.email_id.trim() ||
        internalAccountData?.name.trim() !==
          updatedPayload.account_name.trim(),
    );

    return updatedPayload;
  });

  if (
    name === "account_name" &&
    newValue === internalAccountData?.pan_legal_name
  ) {
    setSelectedValue("legalname");
  }
};


  const handleUpdateInternalAccount = async () => {
    if (isUpdatingAccount) return;

    setIsUpdatingAccount(true);

    try {
      await dispatch(
        updateInternalAccount({
          id,
          email: payload.email_id,
          contact_no: payload.contact_no,
          name: payload.account_name,
        }),
      ).unwrap();

      const updatedFields = getUpdatedFields();

      dispatch(resetEditInternalAccount());

      navigate(
        `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/edit_contact_success/${id}`,
        {
          replace: true,
          state: { updatedFields },
        },
      );
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setIsUpdatingAccount(false);
    }
  };

  useEffect(() => {
    if (
      internalAccountDetailsLoading ||
      internalAccountDetailsData?.status !== true
    ) {
      return;
    }

    const hasChanges =
      internalAccountData?.contact_no !== payload.contact_no ||
      internalAccountData?.email_id !== payload.email_id ||
      internalAccountData?.name.trim() !== payload.account_name.trim();

    const isValid =
      checkAllValidations() &&
      payload.contact_no &&
      payload.email_id &&
      accountNameValidation;

    setIsUpdateButtonEnabled(hasChanges && isValid);
  }, [
    internalAccountDetailsLoading,
    internalAccountDetailsData,
    payload.contact_no,
    payload.email_id,
    payload.account_name,
    contactNumberValidation,
    emailValidation,
  ]);

  useEffect(() => {
    if (
      internalAccountDetailsLoading ||
      internalAccountDetailsData?.status !== true ||
      !internalAccountData
    ) {
      return;
    }

    setPayload((prev) => ({
      ...prev,
      contact_no: internalAccountData.contact_no,
      email_id: internalAccountData.email_id,
      account_name: internalAccountData.name,
      legalName: internalAccountData.pan_legal_name,
    }));

    setSelectedValue(
      internalAccountData.pan_legal_name === internalAccountData.name
        ? "legalname"
        : "customname",
    );
  }, [
    internalAccountDetailsLoading,
    internalAccountDetailsData,
    internalAccountData,
  ]);

  useEffect(() => {
    const fetchContactData = async () => {
      const response = await dispatch(internalAccountDetailsById({ id }));

      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*", { replace: true });
      }
    };

    fetchContactData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (isLoading || !services) return;

    if (!services.includes("IUAccount")) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "IUAccount" },
      });
    }
  }, [services, isLoading, navigate]);

  return (
    <>
      {isLeavePopupOpen && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            subtext={globalText?.EXIT_CURRENT_FLOW_NOTE}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            btnOneText={globalText?.STAY}
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setIsLeavePopupOpen(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleLeavePage}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="bg-primary-bg flex overflow-y-auto flex-col h-full-height">
        <div className="flex flex-col items-center max-w-tab-width-normal mx-auto my-margin-base w-full bg-primary-nav rounded-b-border-radius-md">
          <div className="min-h-navbar-breadcrumb-height hidden Qmd:block"></div>
          <div className="flex justify-center items-end !bottom-bottom-base Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent rounded-t-border-radius-md Qmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-sm w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
            <PrimaryStepper
              activeStep={0}
              handleForwardAction={handleUpdateInternalAccount}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
            <TopNavComponent
              topNavHeader={globalText?.INTERNAL_ACCOUNT}
              topNavSubText={globalText?.CONTACT_DETAILS}
              isFormattingNotRequired
            />
          </div>
          <div className="h-mobile-create-header block Qmd:hidden"></div>
        </div>

        <div className="h-full-height max-w-tab-width-normal mx-auto w-full pt-padding-md px-padding-md Qlg:px-padding-base flex-1">
          <CommonLayout>
            <div>
              {" "}
              <AccountName
                handleChange={handleChange}
                accountNameValidation={accountNameValidation}
                accountName={payload.account_name}
                selectedValue={selectedValue}
                handleDivBtn={handleDivBtn}
                handleRadioBtn={handleRadioBtn}
                selectedRadioValue={selectedValue}
                legalName={payload?.legalName}
                placeHolder="Name"
              />
            </div>

            <div className=" mb-top-md">
              {" "}
              <ContactDetails
                handleChange={handleChange}
                contactNumberValidation={contactNumberValidation}
                emailValidation={emailValidation}
                contactNumber={payload.contact_no}
                emailId={payload.email_id}
                selectedValue={selectedValue}
              />
            </div>
            
          </CommonLayout>
         
        </div>
      </div>
    </>
  );
};

export default InternalAccountEditContact;
